import {mergeConfig} from '../../configStore'
import {field} from '../field'
import type {MultiReferenceField, FieldReturn} from '../../types'

export const multiReference = (
  types: string | string[],
  props?: MultiReferenceField,
  mergeProps?: Partial<MultiReferenceField>,
): FieldReturn => {
  const typesArray = Array.isArray(types) ? types : [types]
  const name = typesArray[0]

  const defaultProps: Partial<MultiReferenceField> = {
    name,
    options: {
      types: typesArray,
    },
  }

  return field('multiReference', mergeConfig('multiReference', props, mergeProps, defaultProps))
}
